import { _ as _check_private_redeclaration } from "./_check_private_redeclaration.js";

function _class_private_method_init(obj, privateSet) {
    _check_private_redeclaration(obj, privateSet);
    privateSet.add(obj);
}
export { _class_private_method_init as _ };
